import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const projectsAPI = {
  getAll: (category = 'all') => {
    const url = category !== 'all' ? `${API}/projects?category=${category}` : `${API}/projects`;
    return axios.get(url);
  },
  getById: (id) => axios.get(`${API}/projects/${id}`)
};

export const contactAPI = {
  submit: (data) => axios.post(`${API}/contact`, data)
};

export const bookingsAPI = {
  create: (data) => axios.post(`${API}/bookings`, data),
  getAvailability: (date) => axios.get(`${API}/bookings/availability?date=${date}`)
};
